import React, { ReactElement, useContext } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { InputWithStatus } from 'src/components/atoms';
import { QuoteContext } from '../../QuoteContext';

interface FormVinProps {
  className?: string;
  show: boolean;
}

const useStyles = makeStyles(() => ({
  root: {
    display: (props: FormVinProps) => (props.show ? 'flex' : 'none'),
    flexDirection: 'column',
  },
}));

const FormVin = (props: FormVinProps): ReactElement => {
  const { className, show } = props;
  const classes = useStyles({ show });
  const { car, handleSetCar } = useContext(QuoteContext);

  const handleChangeVin = (val: string) => {
    handleSetCar({
      ...car,
      search: {
        ...car.search,
        vin: val.toUpperCase(),
      },
    });
  };

  return (
    <Box className={clsx('quote-search-car-form-vin', classes.root, className)}>
      <InputWithStatus
        placeholder="VIN"
        value={car.search.vin}
        valueChanged={handleChangeVin}
      />
    </Box>
  );
};

FormVin.defaultProps = {
  className: undefined,
};

export default FormVin;
